module.exports = __webpack_public_path__ + "static/media/ChildrensATL.719934f8.png";